export default __webpack_public_path__ + "maps-examples-show-hide-layer-960-bf83742b9e4301ebf4acd76fee7ecc64.png";